$(document).ready(function () {

	jQuery.each(jQuery('[data-touch]'), function (e) {
		var $this = $(this);

		var $window = $(this);

		if ($window.width() < 768) {
			$this.removeClass('no-touch').addClass('touch');
			$this.attr('data-touch', true);
		} else {
			$this.addClass('no-touch').removeClass('touch');
			$this.attr('data-touch', false);
		}

		$(window).on('resize', function () {
			var $window = $(this);

			if ($window.width() < 768) {
				$this.removeClass('no-touch').addClass('touch');
				$this.attr('data-touch', true);
			} else {
				$this.addClass('no-touch').removeClass('touch');
				$this.attr('data-touch', false);
			}
		});
	});

	jQuery.each(jQuery('.grid-item:not(.grid-item--position__unset)'), function (e) {
		var $this = $(this);

		$this.mouseover(function (e) {
			$this.addClass('opening');
		}).mouseleave(function (e) {
			$this.removeClass('opening');
		});
	});

	jQuery.each(jQuery('[data-area-name="mobile-aux"] [data-child] a'), function (e) {
		var $this = $(this);

		$this.on('click', function () {
			$('body').removeClass('nav-open');
			$('[data-role="nav-body"]').removeClass('deployed');
			$('[data-role="nav-deployer"]').removeClass('deployed');
		});
	});

	jQuery.each(jQuery('[data-role="video-player"]'), function () {
		var $this_video = $(this);
		var video = this;
		var $deployer = $($this_video.siblings()).find('[data-role="video-player-deployer"]');
		var $video_extras = $($this_video.parent()).find('[data-role="video-extras"]');

		$deployer.on("click", function () {
			var $video_prev = $this_video.siblings('[data-role="video-prev"]');

			if (video.paused == true) {
				video.play();
				$deployer.addClass('playing');
				$this_video.removeAttr('controls');
				$video_prev.addClass('hide').removeClass('paused');
				$video_extras.addClass('hide');
				$($($this_video.parents('.horizon__bouque')).find('.horizon__bouque__leaf')).addClass('hide');
			} else {
				video.pause();
				$video_prev.addClass('paused').removeClass('hide').removeAttr('style');
				$deployer.removeClass('playing');
				$this_video.removeAttr('controls');
				$video_extras.removeClass('hide');
				$($($this_video.parents('.horizon__bouque')).find('.horizon__bouque__leaf')).removeClass('hide');
			}
		});

		if (video.paused == true) {
			$deployer.addClass('check-playing');
		} else {
			$deployer.removeClass('check-playing');
		}
	});

	jQuery.each(jQuery('[data-role="divider-row"]'), function () {
		var $this = $(this),
			$target = $this.children('[data-role="divider-target"]'),
			countext = $target.children().length,
			divider = $this.data('count-paragraph') || 2,
			split = divider / 2 || 2,
			leftcol_qant = Math.round(countext / split),
			contador = 0,
			left_col = '',
			col_html = '',
			right_col = '';

		if (countext >= divider) {
			jQuery.each(jQuery($target.children()), function () {
				var lilkid = $(this).get(0).outerHTML;
				contador++;
				if (contador <= leftcol_qant) {
					left_col += lilkid;
				} else {
					right_col += lilkid;
				}
			});

			col_html = '<td class="left">' + left_col + '</td>' + '<td class="right">' + right_col + '</td>';
			$target.replaceWith(col_html);
		} else {
			var new_html = $target.html();
			$target.replaceWith('<td>' + new_html + '</td><td></td>');
		}
	});

	jQuery.each(jQuery('[data-role="divider-grid"]'), function () {
		var $this = $(this),
			data_class = $this.data('class'),
			countext = $this.children().length,
			divider = $this.data('count-paragraph') || 2,
			split = divider / 2 || 2,
			leftcol_qant = Math.round(countext / split),
			contador = 0,
			left_col = '',
			col_html = '',
			right_col = '';

		if (countext >= divider) {
			jQuery.each(jQuery($this.children()), function () {
				var lilkid = $(this).get(0).outerHTML;
				contador++;
				if (contador <= leftcol_qant) {
					left_col += lilkid;
				} else {
					right_col += lilkid;
				}
			});

			col_html = '<div class="' + data_class + '">' + left_col + '</div>' + '<div class="' + data_class + '">' + right_col + '</div>';
			$this.html(col_html);
		} else {
			var new_html = $this.html();
			$target.html('<div class="' + data_class + '">' + new_html + '</td>');
		}
	});

	jQuery.each(jQuery('[data-role="floating-footer"]'), function () {
		var $hidden = $(this),
			$holder = $(this).parents('[data-role="floating-footer-holder"]'),
			$limit_top = 0;
			// $limit_top = $('#top').height();
		
			$holder.attr('style', 'height: ' + $hidden.height() + 'px; position: inherit; z-index: 10;');
		
		$(window).scroll( function () {
			var scroll = $(window).scrollTop();
         var stop = $holder.offset().top - ($('#top').height() * 1.5);

			if(scroll >= $limit_top && scroll <= stop){
				$hidden.addClass('active');
			}else{					
				$hidden.removeClass('active');
			}
		});
	});

	jQuery.each(jQuery('[data-role="peekaboo"]'), function () {
		var $seeker = $(this);
		var $player = $('[data-name="peekaboo-player"]');

		$seeker.on("click", function () {s

			$player.toggleClass('wait');

			if ($seeker.html() === $seeker.data('less')) {
				$seeker.html($seeker.data('more'));
			} else {
				$seeker.html($seeker.data('less'));
			}
		});
	});

	jQuery.each(jQuery('img[data-srcset]'), function () {
		var $this_img = $(this);
		var src_set = $this_img.data('srcset') || '';

		if(src_set !== ''){
			var sizes = src_set.split(',');
			var resize = [];
			var default_src = $this_img.attr('src');

			if(sizes.length > 0){
				$this_img.attr('data-srcfull', default_src);
				sizes.forEach(function (value, key) {
					value = value.slice(0,-1);
					var size = value.split(' ');

					resize.push({ size: size[1], src: size[0] })
				});
				resize.reverse();
				resize.forEach(function (fuente, key) {
					var window_width = $(window).width();
					if(window_width <= fuente['size']){ $this_img.attr('src', fuente['src']) }
					if(window_width > resize[0]['size']){ $this_img.attr('src', default_src) }
				});
				$(window).on('resize', function () {
					resize.forEach(function (fuente, key) {
						var window_width = $(window).width();
						if(window_width <= fuente['size']){ $this_img.attr('src', fuente['src']) }
						if(window_width > resize[0]['size']){ $this_img.attr('src', default_src) }
					});
				});
			}
		}
	});

	jQuery.each(jQuery('[data-srcset]:not(img)'), function () {
		var $this_figure = $(this);
		var src_set = $this_figure.data('srcset') || '';
		
		if(src_set !== ''){
			var sizes = src_set.split(',');
			var resize = [];
			var default_src = $this_figure.attr('style');
			
			if(sizes.length > 0){
				$this_figure.attr('data-srcfull', default_src);
				sizes.forEach(function (value, key) {
					value = value.slice(0,-1);
					var size = value.split(' ');

					resize.push({ size: size[1], bg: size[0] })
				});

				resize.reverse();
				resize.forEach(function (fuente, key) {
					var window_width = $(window).width();
					if(window_width <= fuente['size']){ $this_figure.attr('style', fuente['bg']) }
					if(window_width > resize[0]['size']){ $this_figure.attr('style', default_src) }
				});
				$(window).on('resize', function () {
					resize.forEach(function (fuente, key) {
						var window_width = $(window).width();
						if(window_width <= fuente['size']){ $this_figure.attr('style', fuente['bg']) }
						if(window_width > resize[0]['size']){ $this_figure.attr('style', default_src) }
					});
				});
			}
		}
	});


	$('[data-role="open-overlay"]').on('click', function(event){
		var $this = $(this);
		var $box = $($this.parents('.box'));
		var $grid = $($this.parents('[data-role="overlay-zone"]'));
		var $overlay = $($grid.find('[data-role="grid-overlay"]'));
		var $close = $($overlay.find('[data-role="overlay-close"]'));

		var box_image = $box.data('image');
		var box_title = $box.data('title');
		var box_excerpt = $box.data('excerpt');
		var box_link = $box.data('link') || '';
		var box_pos = $box.data('pos') || 'start';

		$($overlay.find('[data-role="overlay-background"]')).attr('style', 'background-image: ' + box_image);
		$($overlay.find('[data-role="overlay-title"]')).html(box_title);
		$($overlay.find('[data-role="overlay-excerpt"]')).html(box_excerpt);
		$($overlay.find('[data-role="overlay-link"]')).attr('href', box_link);

		if(box_link == false){
			$($overlay.find('[data-role="parent-link"]')).addClass('hide');
		}else{
			$($overlay.find('[data-role="parent-link"]')).removeClass('hide');
			$($overlay.find('[data-role="overlay-link"]')).attr('target', $box.data('link-target'));
			$($overlay.find('[data-role="overlay-link"]')).text($box.data('link-title'));
		}

		setTimeout(function () {
			$overlay.addClass('active ' + box_pos);
			$('html, body').animate({
				scrollTop: $overlay.offset().top - 200
			}, 250);
		}, 250);

		$close.on('click', function(event){
			setTimeout(function () {
				$overlay.addClass('remove');
				$overlay.removeClass('active ' + box_pos);
			}, 250);
			
			event.preventDefault();
		});

		event.preventDefault();
	});


	jQuery.each(jQuery('[data-func="rotate-child"]'), function () {
		var $lista_rotatoria = $(this);
		var speed = $lista_rotatoria.data('speed') || 3000;
		var cant_lista = $lista_rotatoria.data('total');
		var current = 2;

		setInterval(function() {
			$lista_rotatoria.children().removeClass('active');
			$lista_rotatoria.children('[data-count="'+ current +'"]').addClass('active');
	
			if(current == cant_lista){
				current = 0;
			}
	
			current ++;
		}, speed);
	});


	var vids = $("video.no-controls"); 
	$.each(vids, function(){
		this.controls = false; 
	}); 

	$('[data-button-filter]').on('click', function() {
		var filterValue = $(this).attr('data-button-filter');

		$('.button-group-filter+.row').addClass('loading');
		
		$('.button-group-filter').find('.is-checked').removeClass('is-checked');
		$(this).addClass('is-checked');
		
		if(filterValue == '*') {
			$('.filter-item').show();
		} else {
			$('.filter-item').hide();
			$('.filter-item' + filterValue).show();
		}

		setTimeout(() => {
			$('.button-group-filter+.row').removeClass('loading');
		}, 500);
	});
});